import { SVGProps } from "react";

const SCWICheckmark = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 22 22" {...props}><path d="m17.192 4.41-8.1 11.078-4.4-4.21a1 1 0 0 0-1.383 1.445l5.225 5a1 1 0 0 0 1.5-.133l8.774-12a1 1 0 0 0-1.616-1.18Z" fill="var(--iconFill, #464646)" /></svg>;

export { SCWICheckmark };